import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import { withTranslation } from 'react-i18next';

class CardGrid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            offset: 0,
            data: [],
            perPage: 20,
            currentPage: 0,
            pageCount: 0,
            cards: [],
        };
    }

    handlePageChange(pageNumber) {
        this.setState({ activePage: pageNumber });
    }

    getCards = () => {
        // this.setState({
        //     cards: this.props.cards,
        // });
        const data = this.props.cards;
        const slice = data.slice(
            this.state.offset,
            this.state.offset + this.state.perPage
        );
        const postData = slice.map((card) => (
            <React.Fragment>
                <p>{card}</p>
            </React.Fragment>
        ));

        this.setState({
            pageCount: Math.ceil(data.length / this.state.perPage),
            postData,
        });
    };

    handlePageClick = (e) => {
        const selectedPage = e.selected;
        const offset = selectedPage * this.state.perPage;

        this.setState(
            {
                currentPage: selectedPage,
                offset: offset,
            },
            () => {
                this.getCards();
            }
        );
    };

    componentDidMount() {
        if (this.props.cards.length > 20) {
            this.getCards();
            // console.log('cards', this.props.cards.length);
        } else {
            console.log('cards', this.props.cards.length);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.cards.length !== prevProps.cards.length) {
            this.getCards();
        } else {
            console.log('loaded');
        }
    }

    componentWillUnmount() {
        this.getCards();
    }

    render() {
        const { arrow, cards, t } = this.props;
        return (
            <>
                {cards.length > 20 ? (
                    <>
                        <div className='card_grid_container'>
                            {this.state.postData}
                        </div>
                        <ReactPaginate
                            previousLabel={'<'}
                            nextLabel={'>'}
                            breakLabel={'..'}
                            breakClassName={'break-me'}
                            pageCount={this.state.pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={2}
                            onPageChange={this.handlePageClick}
                            containerClassName={'pagination'}
                            subContainerClassName={'pages pagination'}
                            activeClassName={'active'}
                        />
                    </>
                ) : cards.length < 20 && cards.length > 0 ? (
                    <div className='card_grid_container'>{cards}</div>
                ) : (
                    <div
                        style={{
                            padding: '30px 55px',
                            fontSize: '28px',
                            fontWeight: '600',
                        }}
                    >
                        {t('noResults')}
                    </div>
                )}
            </>
        );
    }
}

export default withTranslation()(CardGrid);
